/*
  MOWE header (sections/header.liquid, assets/mowe-header.css)

  1. Colors follow the page, like on mowewinespace.com: the section right below the header decides.
     The band takes its background, the paper strip its text color, and the strip's text and logo
     its background. Dawn color schemes put both colors on every element as the custom properties
     --color-background / --color-foreground ("r, g, b"), so reading them anywhere inside a section works.
  2. Homepage: the middle of the strip shows the sign-up line while the hero wordmark
     ([data-mowe-hero-wordmark], sections/mowe-poster-hero.liquid) is on screen, then the logo.
*/
(function () {
  var band;
  var strip;
  var lastKey = '';
  var ticking = false;

  function sample() {
    if (!band || !strip || !document.elementsFromPoint) return;
    var rect = band.getBoundingClientRect();
    var y = Math.min(window.innerHeight - 1, Math.max(0, rect.bottom + 2));
    var x = Math.round(window.innerWidth / 2);
    var stack = document.elementsFromPoint(x, y);
    var target = null;
    for (var i = 0; i < stack.length; i++) {
      var el = stack[i];
      if (band.contains(el) || el.closest('dialog, .age-gate__backdrop, .menu-drawer, .search-modal, cart-drawer, cart-notification')) continue;
      target = el;
      break;
    }
    if (!target) return;
    var cs = window.getComputedStyle(target);
    var bg = cs.getPropertyValue('--color-background').trim();
    var fg = cs.getPropertyValue('--color-foreground').trim();
    if (!bg || !fg) return;
    var key = bg + '|' + fg;
    if (key === lastKey) return;
    lastKey = key;
    // All three live on the band: it paints the paper, and the strip inherits the text color
    band.style.setProperty('--mowe-band-bg', bg);
    band.style.setProperty('--mowe-strip-bg', fg);
    band.style.setProperty('--mowe-strip-fg', bg);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      sample();
    });
  }

  function initColors() {
    band = document.querySelector('.mowe-header');
    strip = band ? band.querySelector('.mowe-header__strip') : null;
    if (!band || !strip) return;
    lastKey = '';
    // The first pass sets the colors for this page without a visible fade
    band.classList.add('mowe-header--no-transition');
    sample();
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        band.classList.remove('mowe-header--no-transition');
      });
    });
  }

  function initAnnounce() {
    var announceStrip = document.querySelector('[data-mowe-announce]');
    if (!announceStrip) return;

    // The line opens the popup; without a popup on the page and without a real link it would be a
    // dead end, so the logo shows instead (this script is deferred: the footer is parsed by now)
    var trigger = announceStrip.querySelector('.mowe-header__announce');
    var href = trigger ? trigger.getAttribute('href') : '';
    if (trigger && !document.querySelector('mowe-signup-popup') && (!href || href === '#')) {
      if (announceStrip._moweObserver) announceStrip._moweObserver.disconnect();
      announceStrip.classList.add('mowe-header--show-logo');
      return;
    }

    var wordmark = document.querySelector('[data-mowe-hero-wordmark]');
    if (!wordmark || !('IntersectionObserver' in window)) {
      announceStrip.classList.add('mowe-header--show-logo');
      return;
    }

    if (announceStrip._moweObserver) announceStrip._moweObserver.disconnect();

    var header = document.querySelector('.section-header');
    var offset = header ? header.offsetHeight : 0;

    var observer = new IntersectionObserver(
      function (entries) {
        announceStrip.classList.toggle('mowe-header--show-logo', !entries[0].isIntersecting);
      },
      // The wordmark counts as gone once it is hidden behind the sticky header
      { rootMargin: '-' + offset + 'px 0px 0px 0px', threshold: 0 }
    );
    observer.observe(wordmark);
    announceStrip._moweObserver = observer;
  }

  function init() {
    initColors();
    initAnnounce();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  // Late images or fonts can move sections under the header
  window.addEventListener('load', onScroll);

  // Theme editor: header or another section re-rendered, reordered or selected
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder', 'shopify:section:select'].forEach(function (name) {
    document.addEventListener(name, function () {
      window.setTimeout(init, 0);
    });
  });
})();
